module.exports = "https://coursera_assets.s3.amazonaws.com/images/506bf6d50f5f97ab96bc75c41dfae8d8.png";